export const courseAds = [
  {
    title: 'Selenium WebDriver with Java - Basics to Advanced + Framework',
    subtitle:
      'Master Selenium WebDriver with Java, TestNG, Maven, Jenkins, Git — download real framework code + interview preparation',
    category: 'Automation',
    level: 'Beginner to Advanced',
    url: 'https://www.udemy.com/course/zero-to-hero-in-selenium-webdriver-java-basics-to-advance/?referralCode=CE1EB90EDF90EFA3D6D5',
    thumbnail: 'https://img-c.udemycdn.com/course/750x422/5556178_dacb_11.jpg',
    rating: '4.7',
    udemyBusinessFree: true,
  },
  {
    title: 'Java Programming for Complete Beginners - Zero To Hero',
    subtitle:
      '[2026] Learn Core Java from scratch through practical examples, hands-on coding, and real-world applications.',
    category: 'Java',
    level: 'Beginner to Advanced',
    url: 'https://www.udemy.com/course/core-java-for-automation-testers-selenium-appium-api/?referralCode=6783C460FECC0C0C84BD',
    thumbnail: 'https://img-c.udemycdn.com/course/750x422/5623326_d7c8_3.jpg',
    rating: '4.8',
    udemyBusinessFree: true,
  },
  {
    title: 'ZeroToHero TestNG Framework - From Basics to Advanced',
    subtitle:
      '[2026] Build TestNG Framework from scratch for Selenium, Appium, API Automation Using Java with real-time applications',
    category: 'Automation',
    level: 'Beginner to Advanced',
    url: 'https://www.udemy.com/course/testng-udemy-tutorial/?referralCode=461ABD985440E2F7BEE9',
    thumbnail: 'https://img-c.udemycdn.com/course/750x422/6159851_0df6_6.jpg',
    rating: '4.7',
    udemyBusinessFree: true,
  },
  {
    title: 'ZeroToHero Cucumber BDD Basics + Advanced + Framework Design',
    subtitle:
      '*2026* Cucumber BDD Pro: From Basics to Advanced with Selenium, Java, TestNG, JUnit, Step-by-Step Framework Development',
    category: 'Automation',
    level: 'Beginner to Advanced',
    url: 'https://www.udemy.com/course/cucumber-java-tutorial/?referralCode=A29218DAF04EF769F1AA',
    thumbnail: 'https://img-c.udemycdn.com/course/750x422/6135279_e3d2_5.jpg',
    rating: '4.6',
    udemyBusinessFree: true,
  },
  {
    title: 'Python Programming for Beginners: Zero to Hero Bootcamp',
    subtitle:
      '[2026] Learn Python step by step from scratch with hands-on coding exercises, real-world examples, and practical projects',
    category: 'Programming',
    level: 'Beginner to Advanced',
    url: 'https://www.udemy.com/course/complete-python-programming-bootcamp/?referralCode=01EC1C62E06CDED4B962',
    thumbnail: 'https://img-c.udemycdn.com/course/750x422/7198325_b31a_4.jpg',
    rating: '4.9',
    udemyBusinessFree: false,
  },
  {
    title: 'Git & GitHub for Beginners: Complete Hands-On Masterclass',
    subtitle:
      'Learn Git, GitHub, Branching, Merging, Pull Requests, Collaboration, and Version Control Through Hands-On Examples',
    category: 'DevOps',
    level: 'Beginner to Advanced',
    url: 'https://www.udemy.com/course/master-git-and-github/?referralCode=09BC51A61241E46F3CD8',
    thumbnail: 'https://img-c.udemycdn.com/course/750x422/7217059_2825_12.jpg',
    rating: '4.8',
    udemyBusinessFree: false,
  },
  {
    title: 'Generative AI for Beginners: Prompt Engineering & AI Tools',
    subtitle:
      'Boost your office productivity with ChatGPT, Gemini, Claude, LLM & RAG through practical AI use cases—No Coding Required',
    category: 'AI',
    level: 'Beginner',
    url: 'https://www.udemy.com/course/generative-ai-for-beginners-prompt-engineering-ai-tools/?referralCode=674809B08F49C10411F1',
    thumbnail: 'https://img-c.udemycdn.com/course/750x422/7235573_3c10_2.jpg',
    rating: '4.9',
    udemyBusinessFree: false,
  },
];
